import { createFileRoute } from "@tanstack/react-router";
import { AuditLog, type AuditSearch } from "../../../features/settings/audit";

// The views and ranges are listed here, not imported from the page, so search validation keeps the page lazy.
const VIEWS = ["everything", "signins", "keys", "people", "account"] as const;
const RANGES = ["24h", "7d", "30d", "90d", "1y"] as const;

export const Route = createFileRoute("/_authed/$org/settings/audit")({
  validateSearch: (s: Record<string, unknown>): AuditSearch => ({
    ...(VIEWS.includes(s.view as never) ? { view: s.view as AuditSearch["view"] } : {}),
    ...(RANGES.includes(s.range as never) ? { range: s.range as AuditSearch["range"] } : {}),
    ...(typeof s.q === "string" && s.q ? { q: s.q } : {}),
  }),
  component: AuditPage,
});

function AuditPage() {
  return <AuditLog org={Route.useParams().org} search={Route.useSearch()} />;
}
